import { render, staticRenderFns } from "./DimredPlotView.vue?vue&type=template&id=bd9c6ed6&"
import script from "./DimredPlotView.vue?vue&type=script&lang=js&"
export * from "./DimredPlotView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports